import { Metadata } from "./types"

export const Api = {
    listAllCharts: async (group: string) =>
        fetch(`https://api.chartit.io/list/${group}`)
            .then(res => res.json() as Promise<Metadata[]>),
}
